var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNestDisableImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nest"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4 11.3H3.6V3.30001H16.4M16.4 1.70001H10L8.4 0.100006H3.6C2.712 0.100006 2 0.812006 2 1.70001V11.3C2 11.7244 2.16857 12.1313 2.46863 12.4314C2.76869 12.7314 3.17565 12.9 3.6 12.9H16.4C16.8243 12.9 17.2313 12.7314 17.5314 12.4314C17.8314 12.1313 18 11.7244 18 11.3V3.30001C18 2.87566 17.8314 2.46869 17.5314 2.16864C17.2313 1.86858 16.8243 1.70001 16.4 1.70001Z",
    fill: "#9398AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.5 6.4V8H5.2V10.4L8.4 7.2L5.2 4V6.4H0.5Z",
    fill: "#9398AB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNestDisableImg);
export default __webpack_public_path__ + "static/media/nest-disable-img.01505a55f0d22b53222745776f46cc7a.svg";
export { ForwardRef as ReactComponent };